import axios from 'axios';
import { defaultWeekends } from '@/utils';

const getWeekends = async function getWeekends () {
  const response = await axios.get('/api/settings/weekends');

  return response.data.data;
};

const SET = 'SET';

export default {
  namespaced: true,
  state: () => ({
    dates: [],
  }),
  getters: {
    dates: state => state.dates,
    dateIsWeekend: state => date => state.dates.includes(date),
  },
  actions: {
    async get ({ commit }) {
      const year = new Date().getFullYear();

      try {
        const { dates } = await getWeekends();

        if (dates) {
          return commit(SET, dates.map(el => el.substr(0, 10)));
        }

        commit(SET, defaultWeekends(year));
      } catch (e) {
        commit(SET, defaultWeekends(year));
      }
    },
    set ({ commit }, dates) {
      commit(SET, dates);
    },
  },
  mutations: {
    [SET] (state, dates) {
      state.dates = [...dates];
    },
  },
};
